import { MapPin, Phone, Clock, Mail } from "lucide-react";

export const LocationSection = () => {
  return (
    <section id="locations" className="py-24 md:py-32 bg-[#191646]" data-testid="location-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="text-[#C9A85A] text-sm tracking-[0.2em] uppercase font-body font-semibold mb-3">
            Our Locations
          </p>
          <h2 className="font-heading text-4xl md:text-5xl text-white font-medium tracking-tight mb-4">
            Find Us
          </h2>
          <p className="text-white/50 font-body max-w-lg mx-auto">
            Visit Kiplings for a European bistro experience in the heart of the city.
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          {/* Main location — Hyderabad */}
          <div
            data-testid="location-card-hyderabad-inorbit"
            className="bg-white/5 border border-white/10 overflow-hidden group hover:border-[#C9A85A]/40 transition-all duration-300 mb-6"
          >
            <div className="grid md:grid-cols-[1fr_1fr]">
              <div className="relative overflow-hidden h-56 md:h-auto">
                <img loading="lazy"
                  src="https://customer-assets.emergentagent.com/job_718d3ef2-fc01-4d35-8465-a0773fedecdc/artifacts/mjllmun0_WhatsApp%20Image%202026-05-14%20at%2012.04.10.jpeg"
                  alt="Kiplings at Inorbit Mall Hyderabad"
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 bg-[#C9A85A] text-[#191646] text-xs font-body font-semibold px-3 py-1 tracking-wider uppercase">
                  Now Open
                </div>
              </div>

              <div className="p-8 md:p-10">
                <h3 className="font-heading text-2xl text-white font-medium mb-6">
                  Inorbit Mall, Hyderabad
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start gap-4">
                    <MapPin className="text-[#C9A85A] flex-shrink-0 mt-0.5" size={18} />
                    <p className="text-white/60 font-body text-sm">4th Floor, Inorbit Mall<br/>Hyderabad, Telangana</p>
                  </div>
                  <div className="flex items-start gap-4">
                    <Clock className="text-[#C9A85A] flex-shrink-0 mt-0.5" size={18} />
                    <p className="text-white/60 font-body text-sm">Mon - Sun<br/>11:00 AM - 11:00 PM</p>
                  </div>
                  <div className="flex items-start gap-4">
                    <Phone className="text-[#C9A85A] flex-shrink-0 mt-0.5" size={18} />
                    <a href="tel:+917075179853" className="text-white/60 hover:text-[#C9A85A] font-body text-sm transition-colors">+91 70751 79853</a>
                  </div>
                  <div className="flex items-start gap-4">
                    <Mail className="text-[#C9A85A] flex-shrink-0 mt-0.5" size={18} />
                    <a href="mailto:hi@kiplingsdeli.com" className="text-white/60 hover:text-[#C9A85A] font-body text-sm transition-colors">hi@kiplingsdeli.com</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Coming soon — compact row */}
          <div className="grid grid-cols-2 gap-4">
            <div data-testid="location-coming-soon-delhi" className="bg-white/5 border border-dashed border-white/15 p-5 flex items-center gap-4">
              <div className="w-10 h-10 border border-[#C9A85A]/30 flex items-center justify-center flex-shrink-0">
                <MapPin className="text-[#C9A85A]/50" size={16} />
              </div>
              <div>
                <h4 className="font-heading text-base text-white/40 font-medium">Delhi</h4>
                <p className="text-white/25 font-body text-xs">Coming soon</p>
              </div>
            </div>
            <div data-testid="location-coming-soon-chennai" className="bg-white/5 border border-dashed border-white/15 p-5 flex items-center gap-4">
              <div className="w-10 h-10 border border-[#C9A85A]/30 flex items-center justify-center flex-shrink-0">
                <MapPin className="text-[#C9A85A]/50" size={16} />
              </div>
              <div>
                <h4 className="font-heading text-base text-white/40 font-medium">Chennai</h4>
                <p className="text-white/25 font-body text-xs">Coming soon</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
